module.exports = __webpack_public_path__ + "static/media/SandraDuke.abdb7f36.png";